/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import HeadTittle from "../../../../../../../components/HeadTittle";
import React from "react";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import { EditIcon
} from "../../../../../../../components/buttons/IconButtons";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import ConfirmChangeRequestApp from "../Functionality/ConfirmChangeRequestApp";
import RequestedBatchOverviewTable from "../../Request/SubComponents/RequestedBatchOverviewTable";
import PeriodReviewDetailsSection from "./PeriodReviewDetailsSection";
import {permissionObj} from "../../../../../../../Helpers/permission";
import routes from "../../../../../../../Routes/routes";

const ConfirmChangeRequest = () => {
    const {
        DEV,
        permission,
        navigate,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        objectItems,
        getAttendancePeriodRequest,
        handleUpdate,
        periodReviewItem,
        emptyFields,
        handleChange,
        photoPicker,
        setPhotoPicker,
        isAttendanceSupervisor,
        handleOnBack
    } = ConfirmChangeRequestApp();

    if (!DEV &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_READ) &&
        !permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_REQUEST_READ) &&
        !isAttendanceSupervisor //Used for attendance department supervisor, for can manage attendees, slice loaded in login action
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'updates'}>
                { (DEV || isAttendanceSupervisor || permission?.includes(permissionObj.WEB_ATTENDANCE_SUBMISSION_PERIOD_REVIEW_MANAGE_ATTENDANCES)) &&
                    <ButtonAction
                        id='btn_ccr_update'
                        name='update'
                        Icon={EditIcon}
                        className='btn-icon-edit'
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <div className={"border-full-shades-300 border-radius-8px"} ref={contentCardRef}>
                            <PeriodReviewDetailsSection
                                periodReviewItem={periodReviewItem}
                                emptyFields={emptyFields}
                                handleChange={handleChange}
                                photoPicker={photoPicker}
                                setPhotoPicker={setPhotoPicker}
                            />
                        </div>
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        <RequestedBatchOverviewTable
                            contentTableRef={contentTableRef}
                            attendancePeriod={getAttendancePeriodRequest}
                            statusId={STATUS_MODEL.PENDING}
                            objectItems={objectItems}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default ConfirmChangeRequest;
